import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { VerifyContactsRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { VerifyContactsResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const verifyContacts = (request: VerifyContactsRequest, options?: CashRequestOptions) =>
  post<VerifyContactsRequest, VerifyContactsResponse>('/2.0/cash/verify-contacts', request, {
    ...options,
    rejectOnError: true,
  })
